import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "italic-icon",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M6.87715 2.50122C6.87715 2.15604 7.15697 1.87622 7.50215 1.87622H16.2451C16.5903 1.87622 16.8701 2.15604 16.8701 2.50122C16.8701 2.8464 16.5903 3.12622 16.2451 3.12622H12.3636L8.92681 16.8735H12.4984C12.8436 16.8735 13.1234 17.1533 13.1234 17.4985C13.1234 17.8436 12.8436 18.1235 12.4984 18.1235H8.13823C8.13063 18.1236 8.12301 18.1236 8.11538 18.1235H3.7554C3.41022 18.1235 3.1304 17.8436 3.1304 17.4985C3.1304 17.1533 3.41022 16.8735 3.7554 16.8735H7.63834L11.0751 3.12622H7.50215C7.15697 3.12622 6.87715 2.8464 6.87715 2.50122Z" }, null, -1)
  ])))
}
export default { render: render }